export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
  TIMEOUT: 30000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
};

export const API_ENDPOINTS = {
  AUTH: {
    SEND_CODE: '/auth/send-code',
    VERIFY_CODE: '/auth/verify-code',
    SIGNUP: '/auth/signup',
    LOGIN: '/auth/login',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    ME: '/auth/me',
    CREATE_ADMIN: '/auth/create-admin',
  },

  USER: {
    PROFILE: '/user/profile',
    ACCOUNT_INFO: '/user/account-info',
    CALCULATIONS: '/user/calculations',
    PURCHASED_IDEAS: '/user/purchased-ideas',
    WALLET: '/user/wallet',
    MEMBERSHIP: '/user/membership',
    ACCOUNT: '/user/account',
    UPLOAD_AVATAR: '/user/upload-avatar',
    AVATAR: '/user/avatar',
    DELETE_AVATAR: '/user/avatar',
  },

  MATERIALS: {
    LIST: '/materials',
    CATEGORIES: '/materials/categories',
    PARENT_CATEGORIES: '/materials/parent-categories',
    POPULAR: '/materials/popular',
    SEARCH: '/materials/search',
    BY_ID: (id) => `/materials/${id}`,
    CREATE: '/materials',
    UPDATE: (id) => `/materials/${id}`,
    DELETE: (id) => `/materials/${id}`,
    VIEW: (id) => `/materials/${id}/view`,
    LIKE: (id) => `/materials/${id}/like`,
    UNLIKE: (id) => `/materials/${id}/like`,
    TOGGLE_LIKE: (id) => `/materials/${id}/toggle-like`,
    CREATE_CATEGORY: '/materials/categories',
    UPDATE_CATEGORY: (id) => `/materials/categories/${id}`,
    DELETE_CATEGORY: (id) => `/materials/categories/${id}`,
    CATEGORY_INGREDIENTS: (categoryId) => `/materials/categories/${categoryId}/ingredients`,
    CATEGORY_INGREDIENT: (categoryId, ingredientId) => `/materials/categories/${categoryId}/ingredients/${ingredientId}`,
    INGREDIENT_NAMES: '/materials/ingredient-names',
    INGREDIENT_NAME_BY_ID: (id) => `/materials/ingredient-names/${id}`,
  },

  IDEAS: {
    LIST: '/ideas',
    CATEGORIES: '/ideas/categories',
    HEATING_TYPES: '/ideas/heating-types',
    SIZE_RANGES: '/ideas/size-ranges',
    FEATURED: '/ideas/featured',
    POPULAR: '/ideas/popular',
    SEARCH: '/ideas/search',
    BY_ID: (id) => `/ideas/${id}`,
    CREATE: '/ideas',
    UPDATE: (id) => `/ideas/${id}`,
    DELETE: (id) => `/ideas/${id}`,
    VIEW: (id) => `/ideas/${id}/view`,
    PURCHASE: (id) => `/ideas/${id}/purchase`,
    LIKE: (id) => `/ideas/${id}/like`,
    TOGGLE_LIKE: (id) => `/ideas/${id}/like`,
    TOGGLE_FEATURED: (id) => `/ideas/${id}/featured`,
    CREATE_CATEGORY: '/ideas/categories',
    UPDATE_CATEGORY: (id) => `/ideas/categories/${id}`,
    DELETE_CATEGORY: (id) => `/ideas/categories/${id}`,
    CREATE_HEATING_TYPE: '/ideas/heating-types',
    UPDATE_HEATING_TYPE: (id) => `/ideas/heating-types/${id}`,
    DELETE_HEATING_TYPE: (id) => `/ideas/heating-types/${id}`,
  },

  CALCULATIONS: {
    CREATE: '/calculations',
    TYPES: '/calculations/types',
    HISTORY: '/calculations/history',
    BY_ID: (id) => `/calculations/${id}`,
    UPDATE: (id) => `/calculations/${id}`,
    DELETE: (id) => `/calculations/${id}`,
    BOOKMARK: (id) => `/calculations/${id}/bookmark`,
    SHARE: (id) => `/calculations/${id}/share`,
    STATISTICS: '/calculations/statistics/summary',
  },

  PAYMENTS: {
    LIST: '/payments',
    CREATE: '/payments',
    BY_ID: (id) => `/payments/${id}`,
    VERIFY: (id) => `/payments/${id}/verify`,
  },

  ADMIN: {
    CHANGE_PASSWORD: "/admin/change-password",
    CHANGE_PASSWORD: "/admin/change-password",
    DASHBOARD: '/admin/dashboard',
    USERS: '/admin/users',
    ADMINS: '/admin/admins',
    UPDATE_ADMIN: (id) => `/admin/admins/${id}`,
    DELETE_ADMIN: (id) => `/admin/admins/${id}`,
    DELETE_USER: (id) => `/admin/users/${id}`,
    USER_BY_ID: (id) => `/admin/users/${id}`,
    UPDATE_USER_STATUS: (id) => `/admin/users/${id}/status`,
    UPDATE_USER_PASSWORD: (id) => `/admin/users/${id}/password`,
    BAN_USER: (id) => `/admin/users/${id}/ban`,
    UPDATE_USER_ROLE: (id) => `/admin/users/${id}/role`,
    MATERIALS: '/admin/materials',
    MATERIAL_INGREDIENTS: (id) => `/admin/materials/${id}/ingredients`,
    UPDATE_MATERIAL_INGREDIENTS: (id) => `/admin/materials/${id}/ingredients`,
    PREVIEW_INGREDIENTS: (id) => `/admin/materials/${id}/ingredients/preview`,
    IDEAS: '/admin/ideas',
    SUBSCRIPTIONS: '/admin/subscriptions',
    SUBSCRIPTION_BY_ID: (id) => `/admin/subscriptions/${id}`,
    CREATE_SUBSCRIPTION: '/admin/subscriptions',
    UPDATE_SUBSCRIPTION: (id) => `/admin/subscriptions/${id}`,
    DELETE_SUBSCRIPTION: (id) => `/admin/subscriptions/${id}`,
    TOGGLE_SUBSCRIPTION: (id) => `/admin/subscriptions/${id}/toggle`,
    WITHDRAWALS: '/admin/withdrawals',
    WITHDRAWAL_BY_ID: (id) => `/admin/withdrawals/${id}`,
    CREATE_WITHDRAWAL: '/admin/withdrawals',
    UPDATE_WITHDRAWAL_STATUS: (id) => `/admin/withdrawals/${id}/status`,
    DELETE_WITHDRAWAL: (id) => `/admin/withdrawals/${id}`,
    PURCHASES: '/admin/purchases',
    PURCHASE_BY_ID: (id) => `/admin/purchases/${id}`,
    CREATE_PURCHASE: '/admin/purchases',
    UPDATE_PURCHASE_STATUS: (id) => `/admin/purchases/${id}/status`,
    DELETE_PURCHASE: (id) => `/admin/purchases/${id}`,
    DEPOSITS: '/admin/deposits',
    DEPOSIT_BY_ID: (id) => `/admin/deposits/${id}`,
    CREATE_DEPOSIT: '/admin/deposits',
    UPDATE_DEPOSIT_STATUS: (id) => `/admin/deposits/${id}/status`,
    DELETE_DEPOSIT: (id) => `/admin/deposits/${id}`,
    ANALYTICS_USERS: '/admin/analytics/users',
    ANALYTICS_CALCULATIONS: '/admin/analytics/calculations',
    ANALYTICS_REVENUE: '/admin/analytics/revenue',
    SYSTEM_STATS: '/admin/system/stats',
    SYSTEM_CLEANUP: '/admin/system/cleanup',
    // Manual Users CRUD
    MANUAL_USERS: '/admin/manual-users',
    MANUAL_USER_BY_ID: (id) => `/admin/manual-users/${id}`,
    CREATE_MANUAL_USER: '/admin/manual-users',
    UPDATE_MANUAL_USER: (id) => `/admin/manual-users/${id}`,
    DELETE_MANUAL_USER: (id) => `/admin/manual-users/${id}`,
    // Purchased Ideas
    PURCHASED_IDEAS: '/admin/purchased-ideas',
  },

  MESSAGES: {
    SEND: '/messages/send',
    SEND_IMAGE: '/messages/send-image',
    CONVERSATION: '/messages/conversation',
    USER_MESSAGES: '/messages/user-messages',
    USER_MESSAGES_BY_ID: (userId) => `/messages/user-messages/${userId}`,
    CONVERSATIONS: '/messages/conversations',
    USER_CONVERSATIONS: '/messages/user-conversations', // Yeni endpoint - user conversations listesi
    MARK_READ: '/messages/read',
    MARK_READ_BY_USER: (userId) => `/messages/read/${userId}`,
    ANONYMOUS_SEND: '/messages/anonymous/send',
    ANONYMOUS_SEND_IMAGE: '/messages/anonymous/send-image',
    ANONYMOUS_CONVERSATION: '/messages/anonymous/conversation',
    ANONYMOUS_MESSAGES: '/messages/anonymous/messages',
    ANONYMOUS_SESSIONS: '/messages/anonymous/sessions',
    ANONYMOUS_CONVERSATIONS: '/messages/anonymous/conversations',
    ANONYMOUS_CONVERSATION_MESSAGES: '/messages/anonymous/conversations/messages',
    ANONYMOUS_REPLY: '/messages/anonymous/conversations/reply',
    ANONYMOUS_REPLY_IMAGE: '/messages/anonymous/conversations/reply-image',
  },

  SUBSCRIPTIONS: {
    LIST: '/subscriptions',
    CREATE: '/subscriptions',
    BY_ID: (id) => `/subscriptions/${id}`,
    CANCEL: (id) => `/subscriptions/${id}/cancel`,
  },

  UPLOAD: {
    IMAGE: '/upload/image',
    AVATAR: '/upload/avatar',
    DOCUMENT: '/upload/document',
  },

  SMS_PARSER: {
    PARSE: '/sms-parser/parse',
    RESPONSES: '/sms-parser/responses',
  },

  HEATING_TYPES: {
    LIST: '/heating-types',
    BY_ID: (id) => `/heating-types/${id}`,
  },

  CALCULATION_TYPES: {
    LIST: '/calculations/types',
    BY_ID: (id) => `/calculations/types/${id}`,
  },

  CALCULATION_MATERIALS: {
    LIST: '/calculations/materials',
    BY_ID: (id) => `/calculations/materials/${id}`,
  },

  WALL_THICKNESS: {
    LIST: '/calculations/wall-thickness',
    BY_ID: (id) => `/calculations/wall-thickness/${id}`,
  },

  ROOF_SHAPE: {
    LIST: '/calculations/roof-shape',
    BY_ID: (id) => `/calculations/roof-shape/${id}`,
  },

  HEALTH: '/health',

  SMS_PARSER: {
    RESPONSES: '/sms-parser/responses',
    RESPONSE_BY_ID: (id) => `/sms-parser/responses/${id}`,
    DELETE_RESPONSE: (id) => `/sms-parser/responses/${id}`,
  },
};

export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
};

export const API_RESPONSE_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  LOADING: 'loading',
};

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  MAX_LIMIT: 100,
};

export const FILE_UPLOAD = {
  MAX_SIZE: 10 * 1024 * 1024,
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  ALLOWED_DOCUMENT_TYPES: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
};

export const SOCKET_EVENTS = {
  CONNECTION: 'connection',
  DISCONNECT: 'disconnect',
  NEW_MESSAGE: 'new_message', // For anonymous/backward compatibility
  NEW_USER_MESSAGE: 'new_user_message', // For normal user messages
  MESSAGE_SENT: 'message_sent',
  MESSAGE_RECEIVED: 'message_received',
  USER_TYPING: 'user_typing',
  USER_STOPPED_TYPING: 'user_stopped_typing',
  TEST_CONNECTION: 'test_connection',
};

export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  TIMEOUT_ERROR: 'Request timeout. Please try again.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  FORBIDDEN: 'Access denied.',
  NOT_FOUND: 'Resource not found.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  SERVER_ERROR: 'Server error. Please try again later.',
  UNKNOWN_ERROR: 'An unknown error occurred.',
};

export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Login successful',
  LOGOUT_SUCCESS: 'Logout successful',
  SIGNUP_SUCCESS: 'Registration successful',
  PROFILE_UPDATED: 'Profile updated successfully',
  PASSWORD_CHANGED: 'Password changed successfully',
  DATA_SAVED: 'Data saved successfully',
  DATA_DELETED: 'Data deleted successfully',
};

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'dreamhouse_access_token',
  REFRESH_TOKEN: 'dreamhouse_refresh_token',
  USER_DATA: 'dreamhouse_user_data',
  LANGUAGE: 'dreamhouse_language',
  THEME: 'dreamhouse_theme',
  API_CACHE: 'dreamhouse_api_cache',
  SMS_PARSER_API_KEY: 'dreamhouse_sms_parser_api_key',
};

export const CACHE_CONFIG = {
  DEFAULT_TTL: 5 * 60 * 1000,
  USER_DATA_TTL: 30 * 60 * 1000,
  MATERIALS_TTL: 10 * 60 * 1000,
  IDEAS_TTL: 10 * 60 * 1000,
  CALCULATIONS_TTL: 15 * 60 * 1000,
};

export const API_VERSION = 'v1';

export const ENVIRONMENT = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
  TEST: 'test',
};
